let absenceTable = [
  {
    label: "序号",
    prop: "recordId",
  },
  {
    label: "人员姓名",
    prop: "name",
  },
  {
    label: "科室",
    prop: "departmentName",
  },
  {
    label: "考勤异常类型",
    prop: "type",
  },
  {
    label: "开始时间",
    prop: "beginDate",
  },
  {
    label: "结束时间",
    prop: "endDate",
  },
  {
    label: "时长(天)",
    prop: "duration",
  },
  {
    label: "扣分值",
    prop: "minusScore",
  },
  {
    label: "事由",
    prop: "reason",
  },
  {
    label: "备注",
    prop: "remarks",
  },
]

let absenceList = [
  {
    recordId: 2,
    name: "张三",
    departmentName: "政法科",
    type: "迟到",
    beginDate: "2022-05-03",
    endDate: "2022-05-03",
    duration: "2",
    minusScore: "2",
    reason: "请假",
    remarks: "测试"
  }
]


export {
  absenceTable,
  absenceList
}